import type * as THREE from 'three';

/**
 * Abstraction over "a player in the world". The local player implements this
 * today; a future network layer can implement it for remote players (fed by
 * synced transforms) and reuse the same character rendering + stroke pipeline
 * without refactoring.
 */
export interface PlayerEntity {
  readonly id: string;
  /** Feet position in world space. */
  readonly position: THREE.Vector3;
  readonly yaw: number;
  readonly pitch: number;
  /** Horizontal speed in m/s, for walk animations. */
  readonly speed: number;
  readonly isSpraying: boolean;
  readonly sprayColor: string;
}

export const EYE_HEIGHT = 1.58;
export const PLAYER_RADIUS = 0.35;
